import { CardActionArea, CardHeader, Grid, makeStyles, CardContent, FormControlLabel, Button, Hidden, FormControl, InputLabel, CircularProgress, Backdrop, TextField, InputAdornment } from "@material-ui/core";
import clsx from 'clsx';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';

import braintree from 'braintree-web'

import dropin from "braintree-web-drop-in"

import { getCardIcon } from 'util/creditCard';
import { useTrackEvent } from 'util/trackEvent';
import { createNewCCPaymentMethod, getBraintreeClientToken } from 'services/payments.service';
import { toast } from "react-hot-toast";

import Cards from 'react-credit-cards';
import "react-credit-cards/es/styles-compiled.css";
import { Alert } from "@material-ui/lab";
import ReactJson from "react-json-view";
import InputMask from "react-input-mask";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt, faCreditCard, faUser } from "@fortawesome/free-solid-svg-icons";
import { CreateBraintreePaypalForm } from "./CreateBraintreePaypalForm";
import { toasterror } from "util/toasterror";


const useStyles = makeStyles(theme => ({
  paymentDisabled: {
    color: theme.palette.text.disabled,
  },
  padded: {
    // marginRight: theme.spacing(2),
  },
  input: {
    marginBottom: theme.spacing(1),
  },
  actions: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    '& > *': {
      marginLeft: theme.spacing(2),
    }
  },
  cardIcon: {
    width: '3rem',
    height: '3rem',
    borderRadius: 3,
  },
  fakeInputField: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    padding: "1rem",

    maxHeight: "3rem",

  },
  fieldGroup: {
    display: "grid",
    marginBottom: "1rem",
  },
  formFields: {
    padding: '1rem',
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

const CreateBraintreeCardForm = ({
  onSuccess = () => { },
  onEnterCreateMode = () => { },
  onExitCreateMode = () => { },
}) => {
  const classes = useStyles()

  const [displayCreate, setDisplayCreate] = useState(true);
  const trackEvent = useTrackEvent()

  const [clientInstance, setClientInstance] = useState();
  const [brainTreeToken, setBrainTreeToken] = useState(null);
  const [result, setResult] = useState();
  const cardNumberInput = useRef(null);
  const cardExpirationInput = useRef(null);
  const cardholderNameInput = useRef(null);
  const cardCvvInput = useRef(null);

  const [cardholderNameError, setCardholderNameError] = useState(true);
  const [cardNumberError, setCardNumberError] = useState(true);
  const [cardExpirationError, setCardExpirationError] = useState(true);
  const [cardCvvError, setCardCvvError] = useState(true);

  const [number, setNumber] = useState(null)
  const [name, setName] = useState('')
  const [expiry, setExpiry] = useState('')
  const [cvc, setCvc] = useState('')

  const [error, setError] = useState(null);

  const [braintreeLoading, setBraintreeLoading] = useState(false);

  const [focused, setFocused] = useState(null);
  const handleCallback = useCallback(
    ({ issuer }, isValid) => {

    },
    [],
  );

  const resetCard = useCallback(
    async () => {
      setNumber(null)
      setName('')
      setExpiry('')
      setCvc('')
      setError(null)
      return null
    }, []
  );
  const handleInputFocus = ({ target }) => {
    setFocused(target.id);
    setError(null)
  };

  const handleSubmitCard = useCallback(
    async () => {
      try {
        setBraintreeLoading(true)

        const client = new braintree.api.Client({
          clientToken: brainTreeToken,
        })

        const nonce = client.tokenizeCard({
          number: number,
          cardholderName: name,
          expirationDate: expiry,
          cvv: cvc,
        }, async (err, nonce) => {
          const newPaymentParams = {
            label: 'Personal',
            is_default: 0,
            nonce: nonce,
            gateway_type: 'BRAINTREE',
          }
          try {
            const results = await createNewCCPaymentMethod(newPaymentParams)
            setDisplayCreate(true)
            resetCard()
            // brainTreeToken?.teardown()
            onSuccess()
            setBraintreeLoading(false)
          } catch (error) {
            setError(error?.message?.en || error?.response?.data?.message?.en || error?.response?.data?.details || error?.message)
            setBraintreeLoading(false)
          }
        })
      } catch (error) {
        setError(error?.message?.en || error?.response?.data?.message?.en || error?.response?.data?.details || error.message)
        setBraintreeLoading(false)
      }

    }, [brainTreeToken, number, name, expiry, cvc, onSuccess, setBraintreeLoading]
  );

  const setupBraintreeToken = useCallback(
    async () => {
      try {
        const clientToken = await getBraintreeClientToken()
        setBrainTreeToken(clientToken)

      } catch (error) {
        // toasterror(error?.message?.en || error?.response?.data?.message?.en || error?.response?.data?.details || error?.message)
        setError(error?.message?.en || error?.response?.data?.message?.en || error?.response?.data?.details || error?.message)
      }
      return null
    }, []
  );

  const [paypalForm, setPaypalForm] = useState(false);
  useEffect(
    () => {
      const run = async () => {
        resetCard()
        setBraintreeLoading(true)
        if (!brainTreeToken) {
          await setupBraintreeToken()
        }
        setBraintreeLoading(false)
      }
      if (!displayCreate) {
        run()
      }

      if (!displayCreate) {
        onEnterCreateMode()
      } else {
        onExitCreateMode()
      }
      
    }, [displayCreate]
  );

  const renderMemo = useMemo(
    () => {
      if (paypalForm) {
        return (
          <div className={clsx(classes.padded, classes.root)}>
            <CreateBraintreePaypalForm
              braintreeToken={brainTreeToken}
              onLoading={(loading) => setBraintreeLoading(loading)}
              onSuccess={() => {
                setDisplayCreate(true)
                setPaypalForm(false)
                onSuccess()
              }
              } />
          </div>
        )
      }
      if (displayCreate) {
        return (
          <Grid container className={clsx(classes.padded, classes.root)}>
            <Grid item xs={12} md={6}>
              <CardActionArea onClick={() => {
                trackEvent('Payment - click Add Debit/Credit', {})
                setDisplayCreate(false)
              }}>
                <CardHeader avatar={
                  <img className={classes.cardIcon} src={getCardIcon('card')} alt='credit/debit' />
                } title="Add Debit/Credit" />
              </CardActionArea>
            </Grid>
            <Grid item xs={12} md={6}>
              <CardActionArea onClick={() => {
                trackEvent('Payment - click Add Paypal', {})
                setDisplayCreate(false)
                setPaypalForm(true)

              }}>
                <CardHeader avatar={
                  <img className={classes.cardIcon} src={getCardIcon('paypal')} alt={'paypal'} />
                } title="Use Paypal" />
              </CardActionArea>
            </Grid>
          </Grid>
        )
      }

      return (
        <>
          <CardHeader title="Add a new card" />
          <CardContent>
            <Grid container>
              <Grid item xs={12} md={6}>
                <InputMask
                  mask="9999 9999 9999 9999"
                  value={number}
                  onChange={(e) => setNumber(e.target.value)}
                  disabled={false}
                  maskChar=" "
                >
                  {() => (
                    <TextField
                      className={classes.input}
                      variant="outlined"
                      size="small"
                      id="number"
                      fullWidth
                      label="Card Number"
                      onFocusCapture={handleInputFocus}
                      InputProps={{
                        startAdornment: <InputAdornment position="start"><FontAwesomeIcon icon={faCreditCard} /></InputAdornment>,
                      }}
                    />
                  )}
                </InputMask>

                <TextField
                  className={classes.input}
                  variant="outlined"
                  size="small"
                  id="name"
                  fullWidth
                  label="Cardholder Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  onFocusCapture={handleInputFocus}
                  InputProps={{
                    startAdornment: <InputAdornment position="start"><FontAwesomeIcon icon={faUser} /></InputAdornment>,
                  }}
                />
                <Grid container spacing={1} >
                  <Grid item xs={6}>

                    <InputMask
                      mask="99/99"
                      value={expiry}
                      onChange={(e) => setExpiry(e.target.value)}
                      disabled={false}
                      maskChar=" "
                    >
                      {() => (
                        <TextField
                          className={classes.input}
                          variant="outlined"
                          size="small"
                          id="expiry"
                          fullWidth
                          label="Valid Until"
                          onFocusCapture={handleInputFocus}
                          InputProps={{
                            startAdornment: <InputAdornment position="start"><FontAwesomeIcon icon={faCalendarAlt} /></InputAdornment>,
                          }}
                        />
                      )}
                    </InputMask>
                  </Grid>
                  <Grid item xs={6}>
                    <InputMask
                      mask="9999"
                      value={cvc}
                      onChange={(e) => setCvc(e.target.value)}
                      disabled={false}
                      maskChar=""
                    >
                      {() => (
                        <TextField
                          className={classes.input}
                          variant="outlined"
                          size="small"
                          id="cvc"
                          fullWidth
                          label="CVC"
                          onFocusCapture={handleInputFocus}
                          InputProps={{

                          }}
                        />
                      )}
                    </InputMask>
                  </Grid>
                </Grid>
                {error && <Alert severity="error">{error}</Alert>}
                <div className={classes.actions}>
                  <Button onClick={() => {
                    trackEvent('Payment - Create Card - click Cancel', {})
                    setDisplayCreate(true)
                  }}
                    variant="outlined">Cancel
                  </Button>
                  <Button onClick={() => {
                    trackEvent('Payment - Create Card - click Add Card', {})
                    handleSubmitCard()
                  }} variant="contained" color="primary">Add Card</Button>
                </div>
              </Grid>
              <Grid item xs={12} md={6} >
                {/* <Hidden xsDown> */}
                <Cards
                  number={number??''}
                  name={name}
                  expiry={expiry}
                  cvc={cvc}
                  focused={focused}
                  callback={handleCallback}
                />
                {/* </Hidden> */}
              </Grid>
            </Grid>
          </CardContent>

        </>
      )
    }, [displayCreate, paypalForm, brainTreeToken, number, name, expiry, cvc, error, focused, handleCallback, handleSubmitCard, onSuccess, trackEvent]
  );



  return (
    <>
      <Backdrop className={classes.backdrop} open={braintreeLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      {renderMemo}
    </>
  )

}

export { CreateBraintreeCardForm }